export enum WelcomeStep {
	One = "branding",
	Two = "cms",
	Three = "pricing",
	Four = "integration",
	Done = "done"
}

export const WelcomeStepNumber = {
	[WelcomeStep.One]: 0,
	[WelcomeStep.Two]: 1,
	[WelcomeStep.Three]: 2,
	[WelcomeStep.Four]: 3,
	[WelcomeStep.Done]: 100
};